import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
var styleMap = {
  xlarge: {
    desktop: {
      fontSize: 20,
      lineHeight: 29
    },
    tablet: {
      fontSize: 18,
      lineHeight: 27
    },
    mobile: {
      fontSize: 16,
      lineHeight: 24
    }
  },
  large: {
    desktop: {
      fontSize: 18,
      lineHeight: 27
    },
    tablet: {
      fontSize: 15,
      lineHeight: 27
    },
    mobile: {
      fontSize: 14,
      lineHeight: 24
    }
  },
  medium: {
    desktop: {
      fontSize: 15,
      lineHeight: 27
    },
    tablet: {
      fontSize: 15,
      lineHeight: 27
    },
    mobile: {
      fontSize: 14,
      lineHeight: 24
    }
  },
  small: {
    desktop: {
      fontSize: 13,
      lineHeight: 20
    },
    tablet: {
      fontSize: 12,
      lineHeight: 19
    },
    mobile: {
      fontSize: 11,
      lineHeight: 18
    }
  }
};
export var LParagraph = styled.p.withConfig({
  displayName: "LParagraph",
  componentId: "sc-unpk20-0"
})(["font-size:", "px;font-weight:400;line-height:", "px;& + &{margin-top:1em;}", ";", ";"], function (props) {
  return styleMap[props.size || 'medium'].desktop.fontSize;
}, function (props) {
  return styleMap[props.size || 'medium'].desktop.lineHeight;
}, maxMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: ", "px;\n    line-height: ", "px;\n  "])), function (props) {
  return styleMap[props.size || 'medium'].tablet.fontSize;
}, function (props) {
  return styleMap[props.size || 'medium'].tablet.lineHeight;
}), maxMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: ", "px;\n    line-height: ", "px;\n  "])), function (props) {
  return styleMap[props.size || 'medium'].mobile.fontSize;
}, function (props) {
  return styleMap[props.size || 'medium'].mobile.lineHeight;
}));